const menuItems = [
  {
    items: [
      {
        link: "/organizations",
        text: "Organizations",
        translation: "organizations",
        conditions: [
          { variable: "isAuthenticated", evaluator: true },
          { variable: "hasAccess", evaluator: true },
        ],
        children: [],
      },
      {
        link: null,
        text: "Manage",
        translation: "manage",
        conditions: [
          { variable: "isAuthenticated", evaluator: true },
          { variable: "hasAccess", evaluator: true },
          { variable: "pathMatch", value: "\\/organizations\\/[a-zA-Z0-9]+\\/[a-zA-Z]+\\/(credentials|match-settings|seasons)", evaluator: true}
        ],
        children: [
          {
            link: "/credentials",
            linkReplace: "end",
            text: "Users",
            translation: "users"
          },
          {
            link: "/seasons",
            linkReplace: "end",
            text: "Seasons",
            translation: "seasons"
          }
        ]
      }
    ],
  },
  {
    items: [
      {
        link: "#",
        text: "Login",
        icon: "fas fa-sign-in-alt",
        function: "login",
        conditions: [{ variable: "isAuthenticated", evaluator: false }],
      },
      {
        link: "#",
        text: "UserProfile",
        component: "userprofile",
        conditions: [{ variable: "isAuthenticated", evaluator: true }],
      },
      {
        link: "#",
        text: "LanguageSelect",
        component: "languageselect",
      },
      {
        link: "#",
        text: "",
        icon: "fas fa-sign-out-alt",
        function: "logout",
        conditions: [{ variable: "isAuthenticated", evaluator: true }],
      },
    ],
  },
];

export default menuItems;
